import { render, staticRenderFns } from "./dialog_recharge.vue?vue&type=template&id=2505bc5f&scoped=true&"
import script from "./dialog_recharge.vue?vue&type=script&lang=js&"
export * from "./dialog_recharge.vue?vue&type=script&lang=js&"
import style0 from "./dialog_recharge.vue?vue&type=style&index=0&id=2505bc5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505bc5f",
  null
  
)

export default component.exports